export const gradients = {
  success: 'success-gradient',
  warning: 'warning-gradient',
  error: 'error-gradient',
  primary: 'primary-gradient',
  secondary: 'secondary-gradient',
  actionPrimary: 'action-primary-gradient',
}
